import { Text } from '@chakra-ui/react';
import { CellValue, Row } from 'react-table';

import { IndeterminateCheckbox } from 'components/Table';
import { roles } from 'global/rolesAndPermissions';
import { getUserStore } from 'utils/helpers';

export const getTasksCommonColumns = (t: any) => {
  const userStore = getUserStore();

  return [
    ...(userStore?.userInfo?.roleId === roles.ADMIN ||
    (userStore?.userInfo?.roleId === roles.MANAGER && userStore?.permissions?.manageTimesheets)
      ? [
          {
            id: 'selection',
            width: 30,
            Header: ({ getToggleAllRowsSelectedProps }: any) => {
              return (
                <IndeterminateCheckbox
                  {...getToggleAllRowsSelectedProps()}
                  colorScheme="secondary"
                  data-testid="select-all-checkbox"
                />
              );
            },
            Cell: ({ row }: any) => {
              return (
                <IndeterminateCheckbox
                  {...row.getToggleRowSelectedProps()}
                  colorScheme="secondary"
                  data-testid="select-checkbox"
                />
              );
            },
          },
        ]
      : []),
    {
      Header: t('jobsTasks:taskName'),
      accessor: 'name',
      width: 200,
      Cell: (data: CellValue) => {
        return (
          <Text fontWeight="semibold" color="primary.500" mb="1">
            {data.value}
          </Text>
        );
      },
    },
    {
      Header: t('jobsTasks:jobs'),
      accessor: 'assigned_jobs',
      enableSort: true,
      sortType: (rowA: Row<any>, rowB: Row<any>, columnId: string): number => {
        const a = rowA.values[columnId]?.[0]?.name?.toLowerCase() || 'All';
        const b = rowB.values[columnId]?.[0]?.name?.toLowerCase() || 'All';
        return a.localeCompare(b);
      },
      Cell: (data: CellValue) => {
        return (
          <Text fontWeight="semibold" color="primary.500">
            {Array.isArray(data.value) && data.value.length
              ? data.value.length === 1
                ? `${data.value[0]?.name}`
                : `${data.value[0]?.name} and ${data.value.length - 1} others`
              : 'All'}
          </Text>
        );
      },
    },
    {
      Header: t('common:description'),
      accessor: 'description',
      Cell: (data: CellValue) => {
        return data?.value ? data.value : '-';
      },
    },
    {
      Header: t('jobsTasks:billable'),
      accessor: 'billable',
      Cell: (data: CellValue) => {
        return <Text fontWeight="semibold">{data.row.original?.billable ? 'Yes' : 'No'}</Text>;
      },
    },
  ];
};
